import React from 'react';
// import { render } from 'react-dom';
import ReactDOM from 'react-dom/client';
//import App from './containers/App/App';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
